/* Adam Home product page: the prototype's product.html script, driven by the server-rendered markup and the
   product JSON Liquid prints into [data-product-json]. Variant pills, pack savings, sold-out marking,
   price/labels, AJAX add to bag, Buy it now link, sticky bar, gallery dots/lightbox, recommendations. */
(function () {
  var root = document.querySelector('[data-pdp]'); if (!root) return;
  var A = window.AH, $ = function (s) { return root.querySelector(s); };
  var P; try { P = JSON.parse(document.querySelector('[data-product-json]').textContent); } catch (e) { return; }
  var DIMS = A.DIMS, cover = P.cover;
  var form = root.querySelector('[data-product-form]'), idInput = root.querySelector('[data-variant-id]'), qtyInput = root.querySelector('[data-qty-input]');
  var current0 = P.variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || P.variants[0];
  var sel = current0.options.slice(), qty = 1;

  function current() { return P.variants.filter(function (v) { return v.options.join('|') === sel.join('|'); })[0]; }
  function variantFor(oi, val) { var t = sel.slice(); t[oi] = val; return P.variants.filter(function (v) { return v.options.join('|') === t.join('|'); })[0]; }
  /* multipacks: how many items a value holds, e.g. "4 Pack", "16 X 16 (Pack of 2)", "2 Count (Pack of 1)" */
  function units(val) { var m = /(\d+)\s*Count/i.exec(val) || /(\d+)\s*Pack\b/i.exec(val) || /Pack of (\d+)/i.exec(val); return m ? +m[1] : 0; }
  var optVals = P.options.map(function (_, oi) { return Array.prototype.map.call(root.querySelectorAll('[data-opt="' + oi + '"] [data-oi]'), function (b) { return b.getAttribute('data-val'); }); });
  var packIdx = -1;
  optVals.forEach(function (vals, oi) { if (vals.length > 1 && vals.every(function (v) { return units(v) > 0; }) && new Set(vals.map(units)).size > 1) packIdx = oi; });
  if (packIdx > -1) {
    var box = root.querySelector('[data-opt="' + packIdx + '"] [data-vals]'); box.classList.add('opt__vals--packs');
    var hint = root.querySelector('[data-opt="' + packIdx + '"] [data-pack-hint]'); if (hint) hint.hidden = false;
    Array.prototype.slice.call(box.children).sort(function (a, b) { return units(a.getAttribute('data-val')) - units(b.getAttribute('data-val')); }).forEach(function (b) { box.appendChild(b); });
    optVals[packIdx].sort(function (a, b) { return units(a) - units(b); });
  }
  function saving(val) {
    var v = variantFor(packIdx, val); if (!v) return null;
    var n = units(val), avail = optVals[packIdx].filter(function (x) { return variantFor(packIdx, x); });
    var small = Math.min.apply(null, avail.map(units));
    var smallV = variantFor(packIdx, avail.filter(function (x) { return units(x) === small; })[0]); if (!smallV) return null;
    var full = smallV.price / small * n, save = full - v.price; return { each: v.price / n, full: full, save: save, pct: Math.round(save / full * 100) };
  }
  /* bundles: "4.5 Tog Duvet & Pillow" vs "4.5 Tog Duvet" + "Cot Pillow Only" sold separately on the same product */
  var bundleIdx = -1;
  function bundleSave(val) {
    if (bundleIdx < 0) return null;
    var m = /^(.+?)\s*&\s*(.+)$/.exec(val); if (!m) return null;
    var base = m[1].trim(), addon = m[2].trim().toLowerCase(), vals = optVals[bundleIdx];
    var addVal = vals.filter(function (x) { return x !== val && x.indexOf('&') < 0 && x.toLowerCase().replace(/\s*only$/, '').split(' ').indexOf(addon) > -1; })[0];
    var vB = variantFor(bundleIdx, val), vBase = variantFor(bundleIdx, base), vAdd = addVal ? variantFor(bundleIdx, addVal) : null;
    if (!vB || !vBase || !vAdd) return null;
    var save = vBase.price + vAdd.price - vB.price; return save >= 50 ? save : null;
  }
  if (packIdx < 0 && P.options.length === 1) {
    bundleIdx = 0;
    if (!optVals[0].some(function (x) { return bundleSave(x); })) bundleIdx = -1;
    else { var bb = root.querySelector('[data-opt="0"] [data-vals]'); if (bb) bb.classList.add('opt__vals--bundle'); }
  }
  /* cross-product bundle: e.g. "Pillow And Pillowcover" vs "Pillowcover Only" + the pillow sold as its own product (custom.bundle_item) */
  var xIdx = -1, xOnly = null;
  if (P.bundleItem && bundleIdx < 0 && packIdx < 0) {
    optVals.forEach(function (vals, oi) { var only = vals.filter(function (x) { return /\bonly\b/i.test(x); }); if (xIdx < 0 && only.length === 1 && vals.length === 2) { xIdx = oi; xOnly = only[0]; } });
  }
  function crossSave(val) {
    if (xIdx < 0 || val === xOnly) return null;
    var v = variantFor(xIdx, val); if (!v) return null;
    var onlyPrices = P.variants.filter(function (x) { return x.options[xIdx] === xOnly; }).map(function (x) { return x.price; });
    if (!onlyPrices.length) return null;
    var s = Math.min.apply(null, onlyPrices) + P.bundleItem.price - v.price; return s >= 50 ? s : null;
  }
  if (xIdx > -1) { var xb = root.querySelector('[data-opt="' + xIdx + '"] [data-vals]'); if (xb) xb.classList.add('opt__vals--bundle'); }
  function label(v) { return v ? v.options.filter(function (x) { return x !== 'Default Title'; }).join(' · ') : ''; }

  function render(push) {
    var v = current(), price = v ? v.price : Math.min.apply(null, P.variants.map(function (x) { return x.price; }));
    /* option pills */
    P.options.forEach(function (_, oi) {
      var wrap = root.querySelector('[data-opt="' + oi + '"]'); if (!wrap) return;
      var s = wrap.querySelector('[data-opt-sel]'); if (s) s.textContent = sel[oi];
      wrap.querySelectorAll('[data-oi]').forEach(function (b) {
        var val = b.getAttribute('data-val'), vv = variantFor(oi, val), ok = !!vv, sold = ok && !vv.available;
        b.setAttribute('aria-pressed', sel[oi] === val ? 'true' : 'false');
        b.classList.toggle('is-out', !ok); b.classList.toggle('is-sold', sold);
        if (!ok) b.title = 'Not available with this choice'; else if (sold) b.title = 'Sold out'; else b.removeAttribute('title');
        if (oi === packIdx) {
          var sv = ok && !sold ? saving(val) : null;
          b.innerHTML = sv ? (sv.pct >= 1 ? '<span class="save">Save ' + sv.pct + '%</span>' : '') + '<b>' + A.esc(val.replace(/\s*-\s*50 x 75 CM/i, '')) + '</b><small>' + A.money(sv.each) + ' each</small>' : A.esc(val) + (sold ? '<small>Sold out</small>' : '');
        } else if (oi === xIdx && ok && !sold && crossSave(val)) {
          b.innerHTML = '<span class="save">Save ' + A.money(crossSave(val)) + '</span>' + A.esc(val);
        } else if (oi === bundleIdx && ok && !sold && bundleSave(val)) {
          b.innerHTML = '<span class="save">Save ' + A.money(bundleSave(val)) + '</span>' + A.esc(val);
        } else if (!cover || P.options.length > 1) {
          b.innerHTML = A.esc(val) + (sold ? '<small>Sold out</small>' : '');
        } else {
          var priceTag = vv ? '<small>' + A.money(vv.price) + '</small>' : '';
          b.innerHTML = A.esc(val) + priceTag + (sold ? '<small>Sold out</small>' : '');
        }
      });
    });
    if (cover) {
      var d = $('[data-dims]'); if (d) d.textContent = DIMS[sel[0]] || '';
      var g = $('[data-sg-link]'); if (g) g.href = g.href.split('#')[0] + '#bed-' + String(sel[0]).toLowerCase().replace(/ /g, '-');
    }
    /* price block */
    $('[data-price]').textContent = A.money(price);
    var was = $('[data-was]'); if (v && v.compare > v.price) { was.hidden = false; was.textContent = A.money(v.compare); } else was.hidden = true;
    var sp = $('[data-saving]'), sv0 = packIdx > -1 && v ? saving(sel[packIdx]) : null;
    if (sv0 && sv0.pct >= 1) { sp.hidden = false; sp.textContent = 'Save ' + sv0.pct + '% vs smaller packs · ' + A.money(sv0.each) + ' each'; } else sp.hidden = true;
    var bs0 = bundleIdx > -1 && v ? bundleSave(sel[bundleIdx]) : null;
    if (bs0) { sp.hidden = false; sp.textContent = 'Save ' + A.money(bs0) + ' vs buying separately'; }
    var xs0 = xIdx > -1 && v ? crossSave(sel[xIdx]) : null;
    if (xs0) { sp.hidden = false; sp.textContent = 'Save ' + A.money(xs0) + ' vs buying the pillow and case separately'; }
    $('[data-price-label]').textContent = cover ? 'Duvet cover set, ' + sel[0] + ', with ' + (sel[0] === 'Single' ? 'one 54×77 cm pillowcase' : 'two 54×77 cm pillowcases') : label(v);
    /* buttons */
    var ok = v && v.available, add = $('[data-addbtn]');
    add.disabled = !ok; add.textContent = v ? (v.available ? 'Add to bag · ' + A.money(price * qty) : 'Sold out') : 'Unavailable';
    if (v) idInput.value = v.id; qtyInput.value = qty;
    var bn = $('[data-buynow]'); if (bn && v) bn.href = bn.getAttribute('href').replace(/\/[0-9]+:[0-9]+$/, '/' + v.id + ':' + qty);
    var dyn = $('[data-buynow-dynamic]'); if (dyn) dyn.style.display = ok ? '' : 'none';
    /* sticky */
    var st = document.querySelector('[data-sticky]');
    if (st) {
      st.querySelector('[data-sticky-price]').textContent = A.money(price * qty);
      st.querySelector('[data-sticky-opt]').textContent = cover ? sel[0] + ' · ' + (DIMS[sel[0]] || '') : (label(v) || 'One size');
      var sb = st.querySelector('[data-sticky-add]'); sb.disabled = !ok; sb.textContent = ok ? 'Add to bag' : 'Sold out';
      if (v && v.img) st.querySelector('[data-sticky-img]').src = v.img;
    }
    if (push && v) {
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
      if (v.media) lead(v.media);
    }
  }

  /* gallery: bring the variant's photo to the front, keep seven visible */
  var G = root.querySelector('[data-gal]'), dots = root.querySelector('[data-dots]');
  function lead(mediaId) {
    var f = G.querySelector('[data-media-id="' + mediaId + '"]'); if (!f || f === G.firstElementChild) return;
    G.insertBefore(f, G.firstElementChild);
    Array.prototype.forEach.call(G.children, function (fig, i) { fig.hidden = i >= 7; });
    G._touched = false; G.scrollTo({ left: 0, behavior: 'instant' });
    if (dots) dots.querySelectorAll('i').forEach(function (d, k) { d.classList.toggle('on', k === 0); });
  }
  if (G) {
    var keep = function () { if (!G._touched) G.scrollTo({ left: 0, behavior: 'instant' }); };
    G.querySelectorAll('img').forEach(function (im) {
      var wide = function () { if (im.naturalWidth > im.naturalHeight * 1.4) im.classList.add('is-wide'); };
      if (im.complete) wide(); else im.addEventListener('load', function () { wide(); keep(); }, { once: true });
    });
    requestAnimationFrame(keep); setTimeout(keep, 300); addEventListener('load', keep, { once: true });
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) { G.addEventListener(ev, function () { G._touched = true; }, { passive: true }); });
    G.addEventListener('scroll', function () { var f = G.firstElementChild; if (!f) return; var gap = parseFloat(getComputedStyle(G).columnGap) || 0, i = Math.round(G.scrollLeft / (f.offsetWidth + gap)); if (dots) dots.querySelectorAll('i').forEach(function (d, k) { d.classList.toggle('on', k === i); }); }, { passive: true });
    var lb = document.querySelector('[data-lightbox]');
    G.addEventListener('click', function (e) { var f = e.target.closest('figure'); if (!f || innerWidth < 961 || !lb) return; lb.querySelector('img').src = f.getAttribute('data-full'); lb.classList.add('is-on'); });
    if (lb) lb.addEventListener('click', function () { lb.classList.remove('is-on'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb) lb.classList.remove('is-on'); });
  }

  /* interactions */
  root.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-oi]');
    if (b) {
      var oi = +b.getAttribute('data-oi'), val = b.getAttribute('data-val'); sel[oi] = val;
      if (!current()) { var m = P.variants.filter(function (v) { return v.options[oi] === val; })[0]; if (m) sel = m.options.slice(); }
      render(true); return;
    }
    var d = ev.target.closest('[data-qd]'); if (d) { qty = Math.max(1, Math.min(20, qty + +d.getAttribute('data-qd'))); root.querySelector('[data-qty]').textContent = qty; render(false); return; }
  });
  function addNow(btn) {
    var v = current(); if (!v || !v.available) return;
    if (btn) btn.setAttribute('aria-busy', 'true');
    A.addItems([{ id: v.id, quantity: qty }], btn).catch(function () {}).then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addNow(form.querySelector('[data-addbtn]')); });
  var sticky = document.querySelector('[data-sticky]');
  if (sticky) sticky.addEventListener('click', function (e) { if (e.target.closest('[data-sticky-add]')) addNow(e.target.closest('[data-sticky-add]')); });

  /* sticky add bar: phones from load, desktop after scrolling, only while the main button is off-screen */
  function stickCheck() {
    var btn = root.querySelector('[data-addbtn]'); if (!btn || !sticky) return;
    var r = btn.getBoundingClientRect(), on = (innerWidth < 961 || scrollY > 160) && (r.bottom < 0 || r.top > innerHeight - 80);
    sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
  }
  addEventListener('scroll', stickCheck, { passive: true }); addEventListener('resize', stickCheck); setTimeout(stickCheck, 50);

  render(false);

  /* product recommendations fallback for the "More like this" row */
  document.querySelectorAll('[data-recs]').forEach(function (el) {
    fetch(el.getAttribute('data-recs')).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html; var g = d.querySelector('[data-recs-result]');
      if (g && g.children.length) el.innerHTML = g.innerHTML; else { var s = el.closest('.rel'); if (s) s.remove(); }
    }).catch(function () {});
  });
})();
